import { Nullable } from '@dxb-web-ui-framework/common/types';
import { RoutingTransferTypes } from '../../../../../fundTransfer/src/domain/Transfer/entities/RoutingResponseDTO';

class Mandate {
  status: string;
  account: string;
  userId: string;
  postingDate: string;
  amount: string;
  currency: string;
  transactionId: string;
  beneficiaryName: string;
  accountId: number;
  orderDirection: string;
  globalOrderId: number;
  orderMessageType: string;
  accountNumber: string;
  customerId: number;
  orderProcessType: string;
  processStatus: string;
  eligibleForDealerRate: boolean;
  username: string;
  transferType: Nullable<RoutingTransferTypes>;

  constructor(
    status: string,
    account: string,
    userId: string,
    postingDate: string,
    amount: string,
    currency: string,
    transactionId: string,
    beneficiaryName: string,
    accountId: number,
    orderDirection: string,
    globalOrderId: number,
    orderMessageType: string,
    accountNumber: string,
    customerId: number,
    orderProcessType: string,
    processStatus: string,
    eligibleForDealerRate: boolean,
    username: string,
    transferType: Nullable<RoutingTransferTypes>,
  ) {
    this.status = status;
    this.account = account;
    this.userId = userId;
    this.postingDate = postingDate;
    this.amount = amount;
    this.currency = currency;
    this.transactionId = transactionId;
    this.beneficiaryName = beneficiaryName;
    this.accountId = accountId;
    this.orderDirection = orderDirection;
    this.globalOrderId = globalOrderId;
    this.orderMessageType = orderMessageType;
    this.accountNumber = accountNumber;
    this.customerId = customerId;
    this.orderProcessType = orderProcessType;
    this.processStatus = processStatus;
    this.eligibleForDealerRate = eligibleForDealerRate;
    this.username = username;
    this.transferType = transferType;
  }
}

export default Mandate;
